import { defineAsyncComponent } from "vue"
export { default as ButtonPlayV2 } from "./ButtonPlayV2/ButtonPlayV2.vue"
export { default as FormFieldPlay } from "./FormFieldPlay/FormFieldPlay.vue"
export { default as SelectPlayV2 } from "./SelectPlayV2/SelectPlayV2.vue"
export { default as MultiselectPlayV2 } from "./MultiselectPlayV2/MultiselectPlayV2.vue"
export { default as ModalPlay } from "./ModalPlay/ModalPlay.vue"
export { default as BreadcrumbPlay } from "./BreadcrumbPlay/BreadcrumbPlay.vue"
export { default as AccordionPlay } from "@/components/common/AccordionPlay/AccordionPlay.vue"

// Moved from atoms
export { default as DropdownPlay } from "./DropdownPlay/DropdownPlay.vue"
export { default as TabsPlayV2 } from "./TabsPlayV2/TabsPlayV2.vue"
export { default as PaginationPlay } from "./PaginationPlay/PaginationPlay.vue"
export { default as ToastPlay } from "./ToastPlay/ToastPlay.vue"
export { default as StarRatingPlay } from "./StarRatingPlay/StarRatingPlay.vue"
export { default as InputDateTimePlay } from "./InputDateTimePlay/InputDateTimePlay.vue"
export { default as FieldPlay } from "./FieldPlay/FieldPlay.vue"

export { default as TablePlay } from "./TablePlay/TablePlay.vue"

export const ImagePickerPlay = defineAsyncComponent(() => import("./ImagePickerPlay/ImagePickerPlay.vue"))
export const TelInputPlay = defineAsyncComponent(() => import("./TelInputPlay/TelInputPlay.vue"))
export const DatePickerPlay = defineAsyncComponent(() => import("./DatePickerPlay/DatePickerPlay.vue"))

/**
 * ! ATENÇÃO
 * Mantenha esse código, para que novos membros sigam o padrão
 *
 * se o seu component for pesado, e utiliza biblioteca de terceiros, export da forma abaixo:
 *
 * @example export const MyAsyncComponent = () => import("./MyAsyncComponent.vue")
 */

export const TextEditorPlay = defineAsyncComponent(() => import("./TextEditorPlay/TextEditorPlay.vue"))

export const Editor = defineAsyncComponent(() => import("@/components/common/ContentEditor/ContentEditor.vue"))


export const CaptchaButton = defineAsyncComponent(() => import("@/components/common/CaptchaButton/CaptchaButton.vue"))

export const ModalTutorOnlineDelete = defineAsyncComponent(() => import("@/components/modals/ModalTutorOnlineDelete.vue"))

export { default as LessonComment } from "./LessonComment/LessonComment.vue"
